import { jsonCopy } from '../../../utility/genericUtility';
import { datiRappLegaleInizializzato } from '../componentiBase/sezioniAnagrafica';

export const datiRappLegale = jsonCopy(datiRappLegaleInizializzato);
